import { api } from "@/lib/api-client";
import { uploadsApi } from "@/features/uploads/api";
import type { ReferenceEntry, ReferenceInput } from "./types";

function toPayload(input: ReferenceInput) {
  return {
    name: input.name,
    organization: input.organization || null,
    roleTitle: input.roleTitle || null,
    quote: input.quote,
    projectType: input.projectType || null,
    rating: input.rating || null,
    avatarKey: input.avatarKey || null,
    featured: input.featured ?? false,
    url: input.url || null,
    note: input.note || null,
    sortOrder: input.sortOrder ?? 0,
    isPublished: input.isPublished ?? true,
  };
}

export const referencesApi = {
  publicList: () => api.get<ReferenceEntry[]>("/references"),
  list: () => api.get<ReferenceEntry[]>("/references/manage"),
  create: async (input: ReferenceInput, avatarFile?: File | null) => {
    const avatar = avatarFile ? await uploadsApi.image(avatarFile) : null;
    return api.post<ReferenceEntry>("/references", toPayload({ ...input, avatarKey: avatar?.key ?? input.avatarKey }));
  },
  update: async (id: string, input: ReferenceInput, avatarFile?: File | null) => {
    const avatar = avatarFile ? await uploadsApi.image(avatarFile) : null;
    return api.patch<ReferenceEntry>(`/references/${id}`, toPayload({ ...input, avatarKey: avatar?.key ?? input.avatarKey }));
  },
  delete: (id: string) => api.delete<void>(`/references/${id}`),
};
